import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {closeExamEdit, saveEditExam} from '../../../redux/actions/exams';
import GridEditForm from './GridEditForm';
import {cloneDeep} from 'lodash';
import {delay} from '@helpers/functions';
import Button from '@material-ui/core/Button';
import {withTranslation} from "react-i18next";

class GridEdit extends React.Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }
    handleClose = () => {
        const {closeExamEdit} = this.props;
        closeExamEdit();
    };
    handleSave = () => {
        const {saveEditExam, t} = this.props;
        delay(() => saveEditExam(t), 200);
    };
    render() {
        const {handleClose, handleSave} = this;
        const {gridEditStatus, t} = this.props;
        return (
            <Dialog
                open={gridEditStatus}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>
                    {t('add_entrance_test')}
                </DialogTitle>
                <DialogContent>
                    <GridEditForm />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t('cancel')}
                    </Button>
                    <Button onClick={handleSave} color="primary" autoFocus>
                        {t('save')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    };
}

function mapStateToProps(state) {
    return {
        gridEditStatus: cloneDeep(state.examEditStatus),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeExamEdit,
        saveEditExam,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GridEdit));